import { render } from "./ComparisonTable.vue?vue&type=template&id=06a1d761&scoped=true"
import script from "./ComparisonTable.vue?vue&type=script&lang=js"
export * from "./ComparisonTable.vue?vue&type=script&lang=js"

import "./ComparisonTable.vue?vue&type=style&index=0&id=06a1d761&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a1d761"],['__file',"src/components/offersDetails/ComparisonTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06a1d761"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06a1d761', __exports__)) {
    api.reload('06a1d761', __exports__)
  }
  
  module.hot.accept("./ComparisonTable.vue?vue&type=template&id=06a1d761&scoped=true", () => {
    api.rerender('06a1d761', render)
  })

}


export default __exports__